import { Space, Skeleton, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import React from 'react';
import classes from './ProductCard.module.scss';
import Button from '../../components/UI/Button/Button';

const Info = ({
  product,
  activity,
  denominations,
  selectedDenomination,
  setSelectedDenomination,
  quantity,
  setQuantity,
  onAdd,
  isAddDisabled,
  showLimitMessage
}) => {
  const { t, i18n } = useTranslation();

  return (
    <Space size={20} direction='vertical'>
      <Skeleton title={false} paragraph={{ rows: 1 }} loading={activity} active>
        <Space size={20} direction='vertical'>
          <h3>{t('pages.productCard.product')}</h3>
          <Typography>
            {i18n.language === 'en' ? product?.name : product?.name_lv}
          </Typography>
        </Space>
      </Skeleton>

      <Skeleton title={false} paragraph={{ rows: 2 }} loading={activity} active>
        <Space style={{ width: '100%' }} size={20} direction='vertical'>
          <h3>{t('pages.productCard.nominal')}</h3>
          <div className={classes.products}>
            {denominations.map((d) => (
              <div
                key={d.id}
                onClick={() => setSelectedDenomination(d)}
                className={`${classes.products__item} ${selectedDenomination?.id === d.id ? classes.active : ''}`}
              >
                {`${i18n.language === 'en' ? d.name : d.name_lv} EUR ${d.price}`}
              </div>
            ))}
          </div>
        </Space>
      </Skeleton>

      <Space size={20} direction='vertical'>
        <h3>{t('pages.productCard.quantity')}</h3>
        <Space size={30}>
          <div
            className={`${classes.quantityBtn} ${quantity === 1 ? classes.disabled : ''}`}
            onClick={
              quantity === 1 ? null : () => setQuantity((prev) => prev - 1)
            }
          >
            -
          </div>
          <Typography style={{ fontSize: 18 }}>{quantity}</Typography>
          <div
            className={`${classes.quantityBtn} ${isAddDisabled ? classes.disabled : ''}`}
            onClick={
              isAddDisabled ? null : () => setQuantity((prev) => prev + 1)
            }
          >
            +
          </div>
        </Space>
      </Space>

      {selectedDenomination && selectedDenomination.stock < quantity && (
        <Typography style={{ color: 'red', fontSize: 18, fontWeight: 700 }}>
          {t('pages.productCard.outOfStock')}
        </Typography>
      )}

      {showLimitMessage && (
        <Typography style={{ color: 'red', fontSize: 16 }}>
          {t('cart.limit.quantity')}
        </Typography>
      )}

      <Button
        disabled={
          !selectedDenomination ||
          selectedDenomination.stock < quantity ||
          isAddDisabled
        }
        wide
        mode='contained'
        onClick={onAdd}
      >
        {t('pages.productCard.buy')}
      </Button>
    </Space>
  );
};

export default Info;
